import * as getters from './getters'
import * as actions from './actions'


const NEWSFEED = 'feed';
const REMOVE_FROM_FEED = "remove_from_feed";
const initialState = {
  feed: []
}

const mutations = {
  [NEWSFEED](state, feed) {
    state.feed = feed
  },
  [REMOVE_FROM_FEED](state, index) {
    state.feed.splice(index, 1);
  }
}

export default {
  state: { ...initialState },
  actions,
  getters,
  mutations
}
